import { Feature, useIsUserPermittedTo } from '@occc/utils-access-control';
import { TableContainer, TableHeader } from '@occc-app/design-system';

import { useGetTriggeredMessages } from './use-get-triggered-messages';
import { TriggeredMessagesTable } from './triggered-messages-table';

import { TRIGGERED_MESSAGES_LIST_TABLE_TITLE } from '../triggered-messages-list.constants';

type TriggeredMessagesTableContainerProps = {
  scope?: string;
};

export const TriggeredMessagesTableContainer = (props: TriggeredMessagesTableContainerProps) => {
  const { scope } = props;

  const isUserPermittedToEdit = useIsUserPermittedTo(Feature.TRIGGERED_MESSAGES_EDIT);
  const triggeredMessages = useGetTriggeredMessages(scope);

  return (
    <TableContainer>
      <TableHeader title={TRIGGERED_MESSAGES_LIST_TABLE_TITLE} />
      <TriggeredMessagesTable
        isUserPermittedToEdit={isUserPermittedToEdit}
        loading={triggeredMessages.loading}
        error={triggeredMessages.error}
        paginationProps={triggeredMessages.paginationProps}
        messages={triggeredMessages.data}
        scope={scope}
      />
    </TableContainer>
  );
};
